import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { BrowserModule } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './page/dashboard-children/home/home.component';
import { StatsComponent } from './page/dashboard-children/stats/stats.component';
import { Page404Component } from './page/page404/page404.component';
import { BffApiService } from './shared/bff-api.service';
//import {ErrorInterceptor} from "./shared/service/error.interceptor"
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTreeModule } from '@angular/material/tree';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

@NgModule({
  declarations: [AppComponent, Page404Component, StatsComponent, HomeComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    MatTableModule,
    MatListModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatTreeModule,
    MatIconModule,
    FormsModule,
    MatSnackBarModule,
    NgMultiSelectDropDownModule,
    RouterOutlet,
    ReactiveFormsModule,
  ],
  providers: [BffApiService, provideHttpClient(withInterceptorsFromDi())],
})
export class AppModule {}
